module.exports = __webpack_public_path__ + "static/media/bespoke-opening-illustration.e964e781.png";